import { useEffect, useState } from "react";

// useState that survives reloads and back/forward within the browser tab by
// mirroring its value into sessionStorage. Storage failures (e.g. disabled
// storage) fall back to plain in-memory state.
export default function useSessionState(key, initialValue) {
  const [value, setValue] = useState(() => {
    try {
      const stored = window.sessionStorage.getItem(key);
      if (stored !== null) return JSON.parse(stored);
    } catch (e) {
      // Ignore storage read/parse failures and use the initial value
    }
    return typeof initialValue === "function" ? initialValue() : initialValue;
  });

  useEffect(() => {
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      // Ignore storage write failures (e.g., disabled storage)
    }
  }, [key, value]);

  return [value, setValue];
}

// Remove every sessionStorage key starting with `prefix` (e.g. on logout).
export function clearSessionState(prefix) {
  try {
    Object.keys(window.sessionStorage)
      .filter((k) => k.startsWith(prefix))
      .forEach((k) => window.sessionStorage.removeItem(k));
  } catch (e) {
    // Ignore storage failures
  }
}
